import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getMaterialTypeDayFromProducts } from '../../../helpers/materialTypeDay';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Selector, SelectorImageItem} from '../../Common/Selector';
import { Heading } from '../../Common/Heading';
import { SectionContent } from './SectionContent';
import { mapOptionsOrder } from '../../../helpers/optionsSort';

type OnClick = (
  materialTypeDay: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (materialTypeDay, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      materialTypeDay,
    },
  });

export const MaterialTypeDay = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    products,
    custom: { materialTypeDay },
  } = state.context;
  const productType = getBaseProductType(state.context);
  const materialDayTypes = getMaterialTypeDayFromProducts(products);
  
  if (
    isCurrentState('materialTypeDay', state) &&
    materialDayTypes.length === 0
  ) {
    throwError(state);
  }

  // New requirement, only the Night (back fabric) is allowed to be Blockout
  const materialDayTypesExcludingBlockout = materialDayTypes.filter(
    material => material !== 'Blockout',
  );

  const materialTypesOrder = ['Blockout', 'Light Filter', 'Sunscreen', 'Sheer'];
  let sortedMaterialTypes = mapOptionsOrder(
    materialDayTypesExcludingBlockout,
    materialTypesOrder,
  );

  return (
    <SectionContent>
      <Heading>Material type - day</Heading>
      <Selector isSlider={true}>
        {materialDayTypesExcludingBlockout.map(materialType => {
          const isSelected = materialType === materialTypeDay;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'materialTypeDay',
            materialType,
          );
          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(materialType, send)}
              key={materialType}
              showIcon={showIcon}
              Icon={Icon}
              title={materialType}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
